module.exports = __webpack_public_path__ + "img/b8d1de1429bf7e0ab1edbd874da9888e.1d7a8ad0.png";